import { createContext, useContext } from "react";

type MovementDrawerContextValue = {
  openMovement: (movementId: string) => void
  closeMovement: () => void
};

const MovementDrawerContext = createContext<MovementDrawerContextValue | null>(null);

export const MovementDrawerProvider = MovementDrawerContext.Provider;

export const useMovementDrawer = (): MovementDrawerContextValue => {
  const ctx = useContext(MovementDrawerContext);
  if (!ctx) {
    throw new Error("useMovementDrawer must be used within a MovementDrawerProvider");
  }
  return ctx;
};

/**
 * Optional version — returns null when no provider is present (safe fallback).
 */
export const useMovementDrawerOptional = (): MovementDrawerContextValue | null => {
  return useContext(MovementDrawerContext);
};
